import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { SessionProvider } from "@/session/SessionProvider";
import InvitationGuard from "@/session/InvitationGuard";
import { PlatformDataProvider } from "@/store/platform/PlatformDataProvider";
import { FormulesProvider } from "@/store/formules/FormulesProvider";
import { TerritoryProvider } from "@/store/territory/TerritoryProvider";
import { BillingProvider } from "@/store/billing/BillingProvider";
import { AdministratorsProvider } from "@/store/administrators/AdministratorsProvider";
import { PlatformSettingsProvider } from "@/store/platformSettings/PlatformSettingsProvider";
import DataErrorToaster from "@/components/feature/DataErrorToaster";
import SeoManager from "@/components/feature/SeoManager";
import JsonLdManager from "@/components/feature/JsonLdManager";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SessionProvider>
          <PlatformDataProvider>
            <FormulesProvider>
              <TerritoryProvider>
                <BillingProvider>
                  <AdministratorsProvider>
                    <PlatformSettingsProvider>
                      <SeoManager />
                      <JsonLdManager />
                      <InvitationGuard />
                      <AppRoutes />
                      <DataErrorToaster />
                    </PlatformSettingsProvider>
                  </AdministratorsProvider>
                </BillingProvider>
              </TerritoryProvider>
            </FormulesProvider>
          </PlatformDataProvider>
        </SessionProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;